import { createRoot } from 'react-dom/client'
import App from './App'
import './global.css'
import { initTheme } from './stores/ui'
import { setupAuthEvents } from './stores/auth'

// 注意：刻意不启用 React.StrictMode —— Fluent v9 (griffel) 在 StrictMode 下
// 双挂载会导致样式桶竞争清空/重建，引起控件闪烁（已实测确认）
initTheme()
setupAuthEvents()

createRoot(document.getElementById('root')!).render(<App />)
